document.addEventListener('alpine:init', () => {
  const THUMB_SCROLLBAR_MIN_DRAG = 24;

  function destroyProductThumbScrollbar(section) {
    if (!section) return;
    var cleanup = section._productThumbScrollbarCleanup;
    if (cleanup) {
      cleanup();
      section._productThumbScrollbarCleanup = null;
    }
    section._productThumbScrollbarUpdate = null;
  }

  function initProductThumbScrollbar(section) {
    if (!section) return;
    destroyProductThumbScrollbar(section);

    var scroller = section.querySelector('.product-thumb-scroller');
    var track = section.querySelector('.product-thumb-scroller__track');
    var wrap = section.querySelector('[data-product-thumb-scrollbar]');
    if (!scroller || !track || !wrap) return;

    var sbTrack = wrap.querySelector('.product-thumb-scrollbar__track');
    var drag = wrap.querySelector('.product-thumb-scrollbar__drag');
    if (!sbTrack || !drag) return;

    var vertical = !!scroller.closest('.product__thumbs--beside');

    function update() {
      // no-scroll must be reversible when variant changes restore scrollable thumb lists
      wrap.classList.remove('no-scroll');
      wrap.removeAttribute('hidden');

      if (vertical) {
        var sh = track.scrollHeight;
        var ch = track.clientHeight;
        var maxScroll = sh - ch;
        if (maxScroll <= 1) {
          wrap.classList.add('no-scroll');
          return;
        }

        var trackLen = sbTrack.clientHeight;
        var thumbH = Math.min(
          trackLen,
          Math.max(THUMB_SCROLLBAR_MIN_DRAG, (ch / sh) * trackLen)
        );
        var maxThumbTop = Math.max(0, trackLen - thumbH);
        var ratio = maxScroll > 0 ? track.scrollTop / maxScroll : 0;
        var thumbTop = ratio * maxThumbTop;

        drag.style.height = thumbH + 'px';
        drag.style.width = '100%';
        drag.style.transform = 'translateY(' + thumbTop + 'px)';
      } else {
        var sw = track.scrollWidth;
        var cw = track.clientWidth;
        var maxScroll = sw - cw;
        if (maxScroll <= 1) {
          wrap.classList.add('no-scroll');
          return;
        }

        var trackLen = sbTrack.clientWidth;
        var thumbW = Math.min(
          trackLen,
          Math.max(THUMB_SCROLLBAR_MIN_DRAG, (cw / sw) * trackLen)
        );
        var maxThumbLeft = Math.max(0, trackLen - thumbW);
        var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        var thumbLeft = ratio * maxThumbLeft;

        drag.style.width = thumbW + 'px';
        drag.style.height = '100%';
        drag.style.transform = 'translateX(' + thumbLeft + 'px)';
      }
    }

    section._productThumbScrollbarUpdate = update;

    var onScroll = function() {
      update();
    };
    track.addEventListener('scroll', onScroll, { passive: true });

    var ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    if (ro) {
      ro.observe(track);
      ro.observe(sbTrack);
    }

    var dragging = false;
    var startClient = 0;
    var startScroll = 0;

    function onDragMoveWin(e) {
      if (!dragging) return;
      var maxScroll = vertical
        ? track.scrollHeight - track.clientHeight
        : track.scrollWidth - track.clientWidth;
      var trackLen = vertical ? sbTrack.clientHeight : sbTrack.clientWidth;
      var thumbSize = vertical ? drag.offsetHeight : drag.offsetWidth;
      var range = Math.max(1, trackLen - thumbSize);
      var delta = (vertical ? e.clientY : e.clientX) - startClient;
      var next = startScroll + (delta / range) * maxScroll;
      if (vertical) {
        track.scrollTop = Math.max(0, Math.min(maxScroll, next));
      } else {
        track.scrollLeft = Math.max(0, Math.min(maxScroll, next));
      }
    }

    function onDragEndWin(e) {
      if (!dragging) return;
      dragging = false;
      window.removeEventListener('pointermove', onDragMoveWin);
      window.removeEventListener('pointerup', onDragEndWin);
      window.removeEventListener('pointercancel', onDragEndWin);
      try {
        drag.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onDragPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.stopPropagation();
      e.preventDefault();
      dragging = true;
      startClient = vertical ? e.clientY : e.clientX;
      startScroll = vertical ? track.scrollTop : track.scrollLeft;
      drag.setPointerCapture(e.pointerId);
      window.addEventListener('pointermove', onDragMoveWin);
      window.addEventListener('pointerup', onDragEndWin);
      window.addEventListener('pointercancel', onDragEndWin);
    }

    function onTrackPointerDown(e) {
      if (e.target === drag) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var rect = sbTrack.getBoundingClientRect();
      if (vertical) {
        var sh = track.scrollHeight;
        var ch = track.clientHeight;
        var maxScroll = sh - ch;
        var y = e.clientY - rect.top;
        var thumbH = drag.offsetHeight;
        var maxTop = rect.height - thumbH;
        var t = Math.max(0, Math.min(maxTop, y - thumbH / 2));
        var ratio = maxTop > 0 ? t / maxTop : 0;
        track.scrollTop = ratio * maxScroll;
      } else {
        var sw = track.scrollWidth;
        var cw = track.clientWidth;
        var maxScroll = sw - cw;
        var x = e.clientX - rect.left;
        var thumbW = drag.offsetWidth;
        var maxLeft = rect.width - thumbW;
        var l = Math.max(0, Math.min(maxLeft, x - thumbW / 2));
        var ratio = maxLeft > 0 ? l / maxLeft : 0;
        track.scrollLeft = ratio * maxScroll;
      }
    }

    drag.addEventListener('pointerdown', onDragPointerDown);
    sbTrack.addEventListener('pointerdown', onTrackPointerDown);

    section._productThumbScrollbarCleanup = function() {
      track.removeEventListener('scroll', onScroll);
      if (ro) ro.disconnect();
      drag.removeEventListener('pointerdown', onDragPointerDown);
      sbTrack.removeEventListener('pointerdown', onTrackPointerDown);
      window.removeEventListener('pointermove', onDragMoveWin);
      window.removeEventListener('pointerup', onDragEndWin);
      window.removeEventListener('pointercancel', onDragEndWin);
    };

    requestAnimationFrame(update);
  }

  const GetImageData = ($images) => {
    var haveImages = false;
    var items = [];
    var options = {};

    $images.each(function() {
      var haveImages = true;
      var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
      var item = {
        msrc: smallSrc,
        src: $(this).data('photoswipe-src'),
        w: $(this).data('photoswipe-width'),
        h: $(this).data('photoswipe-height'),
        el: $(this)[0],
        initialZoomLevel: 0.5
      };

      items.push(item);
    });

    return items;
  }

  Alpine.data('ProductImages', (product_id = '') => ({
    $section: null,
    $productSection: null,
    product_id: product_id,
    product: null,
    start_index: 0,
    end_index: 0,
    selected_variant_media: [],
    matte_padded_title: '',
    _mainThumbRo: null,

    init() {
      let am = this;
      am.InitWatchers();
    },

    InitWatchers() {
      let am = this;
      am.$watch('product', () => {
        let $section = document.querySelector(`.custom-product-images[data-product-id="${ am.product.id }"]`);
        if (!$section) return;
        am.$section = $section;

        let $productSection = am.$section.closest('.product-section');
        am.$productSection = $productSection;

        am.matte_padded_title = am.$section.dataset.matte_padded_title;
        am.SetSelectedVariant(am.product.selected_variant);
        am.SetVariantMedia();
      });

      document.addEventListener('variantChange', Alpine.debounce((e) => {
        let $images_dom = document.getElementById(`ProductImages-${ am.product_id }`);
        // console.log($images_dom);
        if (!am.product || !e.detail.variant || !$images_dom) return;
        // console.log('variant-change-handler');
        let $section = document.querySelector(`.custom-product-images[data-product-id="${ am.product.id }"]`);
        if (!$section) return;

        let selectedVariantOptions = [...e.detail.variant.options];
        let variant = am.product.variants.find(v => v.options.join('/') == selectedVariantOptions.join('/'));
        am.SetSelectedVariant(variant);
        am.SetVariantMedia();
      }), 250);
      
      document.addEventListener('product:changed', () => {
        am.product = window.current_product;
      });

      // On page load, set variant if not set yet
      am.$nextTick(() => {
        if (am.selected_variant_media.length) return;
        am.SetVariantMedia();
      });
      document.addEventListener('DOMContentLoaded', () => {
        if (am.selected_variant_media.length) return;
        am.SetVariantMedia();
      });
    },

    SetProduct() {
      let am = this;
      let $script = document.querySelector(`#product-js[data-product-id="${ am.product_id }"]`);
      ConvertStringToJS($script.innerHTML);
      am.product = product;
    },

    SetSelectedVariant(variant) {
      let am = this;
      am.product.selected_variant = variant;
    },

    SetVariantMedia() {
      let am = this;
      let start_index, end_index;

      let product = am.product;
      let selected_variant = am.product.selected_variant;
      let product_media = [...product.images];

      product_media.forEach((media) => {
        let variant = product.variants.find(v => v.featured_media && v.featured_media.id == media.id);
        if (variant) {
          media.variant = variant;
        }
      });

      start_index = product_media.findIndex(m => m.variant && m.variant.id == selected_variant.id);
      if (start_index == -1) {
        let selected_variant_media = product_media.find(m => selected_variant.featured_media && m.id == selected_variant.featured_media.id);
        start_index = selected_variant_media ? product_media.findIndex(m => m.id == selected_variant_media.id) : 0;
      }
      end_index = product_media.findIndex((m, mediaIndex) => (mediaIndex > start_index) && m.variant);
      if (end_index == -1) {
        end_index = product_media.length;
      }
      // console.log({start_index, end_index})

      let material_tag = am.product.tags.find(tag => tag.indexOf('material_') !== -1);
      let hasMatteChanged = false;
      let matte = am.product.selected_variant.option2 !== am.matte_padded_title ? 'Standard' : 'Padded';
      hasMatteChanged = am.$section.dataset.selected_matte !== matte;

      let hasIndexChanged = am.start_index !== start_index || am.end_index !== end_index;
      if (hasIndexChanged) {
        am.start_index = start_index;
        am.end_index = end_index;
        am.selected_variant_media = product_media.slice(start_index, end_index); 
      }

      // remove custom video
      let custom_video_index = am.selected_variant_media.findIndex(item => item && item.type && item.type == 'custom-video');
      if (custom_video_index !== -1) {
        am.selected_variant_media.splice(custom_video_index, 1);
      }
      // insert videos rugs
      let custom_video_added = am.selected_variant_media.filter(item => item && item.type && item.type == 'custom-video').length == 1;
      if (product.custom_videos.length && material_tag && !custom_video_added) {
        let pad_id = am.product.selected_variant.name.indexOf(am.matte_padded_title) !== -1 ? 'm_pad' : 's_pad';
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_${ pad_id }__${ material_tag}`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // insert video - Badematte
      if (product.type == 'Badematte') {
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_badematte`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // insert video - Kissen
      if (product.type == 'Kissen') {
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_kissen`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // insert video - Shaggy
      if (product.custom_videos.length && material_tag && material_tag.includes('shaggy') && !custom_video_added) {
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_shaggy`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // insert video - Stufenmatte
      if (product.custom_videos.length && material_tag && material_tag.includes('stufenmatte') && !custom_video_added) {
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_stufenmatte`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // insert video - Hundebett
      if (product.type == 'Hundebett') {
        let video = am.product.custom_videos.find((video) => {
          return video.id == `video_hundebett`;
        });
        am.selected_variant_media.splice((am.product.video_position - 1), 0, video);
      }
      // console.log(am.selected_variant_media);

      if (hasIndexChanged || hasMatteChanged) {
        // init carousels
        let isCurrentProduct = !am.$productSection.classList.contains('hide-product');
        let DELAY = isCurrentProduct ? 0 : 1000;
        setTimeout(am.InitCarousels.bind(am), DELAY);
      }
    },

    GetSelectedVariantMedia_HTML() {
      let am = this;
      let html = {
        main: am.selected_variant_media.map(media => media && media.main_html).join(''),
        thumbs: am.selected_variant_media.map(media => media && media.thumb_html).join('')
      };

      return html;
    },

    InitCarousels() {
      let am = this;

      if (!am.$section) return;
      if (am.selected_variant_media.length == 0) return;

      let $main = $(am.$section.querySelector('.slick-main-slider'));
      let $thumbs = $(am.$section.querySelector('.slick-thumb-slider'));
      let $thumbTrack = $thumbs.find('.product-thumb-scroller__track');
      if (!$thumbTrack.length) {
        $thumbs.empty().append(
          '<div class="product-thumb-scroller__track"></div>' +
            '<div class="product-thumb-scrollbar" data-product-thumb-scrollbar>' +
            '<div class="product-thumb-scrollbar__track">' +
            '<div class="product-thumb-scrollbar__drag"></div></div></div>'
        );
        $thumbTrack = $thumbs.find('.product-thumb-scroller__track');
      }

      let isMobile = window.matchMedia("(max-width: 768px)").matches;

      let mainSliderArgs = {
        adaptiveHeight: false,
        arrows: false,
        dots: true,
        fade: isMobile ? false : true,
        infinite: false,
        initialSlide: 0
      };

      let hasIndexChanged = (parseInt(am.$section.dataset.start_index) !== am.start_index);
      let matteNow =
        am.product.selected_variant.option2 !== am.matte_padded_title ? 'Standard' : 'Padded';
      let hasMatteChanged = am.$section.dataset.selected_matte !== matteNow;

      let hasImagesChanged = hasIndexChanged || hasMatteChanged;
      if (!hasImagesChanged) return;

      destroyProductThumbScrollbar(am.$section);

      if (am._mainThumbRo) {
        am._mainThumbRo.disconnect();
        am._mainThumbRo = null;
      }

      $thumbTrack.off('click.productImgThumb');
      $main.off('afterChange.productImgSync');

      if ($thumbs.hasClass('slick-initialized')) {
        $thumbs.slick('unslick');
      }

      if ($main.hasClass('slick-initialized')) {
        $main.slick('unslick');
      }
      $main.html(am.GetSelectedVariantMedia_HTML().main);
      $main.slick(mainSliderArgs);

      $thumbTrack.html(am.GetSelectedVariantMedia_HTML().thumbs);

      let trackEl = $thumbTrack[0];
      if (trackEl) {
        trackEl.scrollTop = 0;
        trackEl.scrollLeft = 0;
      }

      $thumbTrack.on('click.productImgThumb', '.product__thumb-item', function () {
        let idx = Array.prototype.indexOf.call($thumbTrack[0].children, this);
        if (idx < 0) return;
        am.PauseAllMainVideos($main);
        am.SetActiveThumb(idx);
        $main.slick('slickGoTo', idx, true);
        requestAnimationFrame(() => {
          am.TryPlayVideoInMainSlide($main, idx);
        });
      });

      $main.on('afterChange.productImgSync', (e, slick, currentIndex) => {
        $(slick.$slides).each((index, item) => {
          let $video = $(item).find('video');
          if ($video.length && index !== currentIndex) {
            $video[0].pause();
          }
        });
        am.TryPlayVideoInMainSlide($main, currentIndex);
        am.SetActiveThumb(currentIndex);
        am.ScrollThumbIntoView(currentIndex);
      });

      document.dispatchEvent(new CustomEvent('product-images-loaded', { bubbles: true }));

      $main.find('.js-photoswipe__zoom').each((index, btn) => {
        btn.dataset.index = (index + 1);
      });
      am.SetActiveThumb(0);
      am.SyncBesideThumbScrollerMaxHeight();
      initProductThumbScrollbar(am.$section);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (am.$section && am.$section._productThumbScrollbarUpdate) {
            am.$section._productThumbScrollbarUpdate();
          }
          am.SyncBesideThumbScrollerMaxHeight();
        });
      });
      document.dispatchEvent(new CustomEvent('initImageZoom', { bubbles: true }));

      am.$section.dataset.start_index = am.start_index;
      am.$section.dataset.end_index = am.end_index;

      let matte = am.product.selected_variant.option2 != am.matte_padded_title ? 'Standard' : 'Padded';
      am.$section.dataset.selected_matte = matte;
    },

    PauseAllMainVideos($main) {
      let slick;
      try {
        slick = $main.slick('getSlick');
      } catch (err) {
        return;
      }
      if (!slick) return;
      $(slick.$slides)
        .find('video')
        .each((_, el) => {
          el.pause();
        });
    },

    TryPlayVideoInMainSlide($main, slideIndex) {
      let slick;
      try {
        slick = $main.slick('getSlick');
      } catch (err) {
        return;
      }
      if (!slick || slideIndex < 0 || slideIndex >= slick.slideCount) return;
      let slideEl = slick.$slides.get(slideIndex);
      if (!slideEl) return;
      let vid = slideEl.querySelector('video');
      if (vid) {
        vid.play().catch(() => {});
      }
    },

    SyncBesideThumbScrollerMaxHeight() {
      let am = this;
      if (!am.$section) return;

      let mainEl = am.$section.querySelector('.slick-main-slider');
      let scrollEl = am.$section.querySelector('.product-thumb-scroller');
      if (!mainEl || !scrollEl) return;

      let apply = () => {
        if (!scrollEl.closest('.product__thumbs--beside')) {
          scrollEl.style.maxHeight = '';
          return;
        }
        let h = mainEl.getBoundingClientRect().height;
        if (h > 0) {
          scrollEl.style.maxHeight = h + 'px';
        }
      };

      apply();
      requestAnimationFrame(apply);

      if (typeof ResizeObserver === 'undefined') return;

      if (am._mainThumbRo) {
        am._mainThumbRo.disconnect();
      }
      am._mainThumbRo = new ResizeObserver(function() {
        apply();
        if (am.$section && am.$section._productThumbScrollbarUpdate) {
          am.$section._productThumbScrollbarUpdate();
        }
      });
      am._mainThumbRo.observe(mainEl);
    },

    SetActiveThumb(index) {
      let am = this;
      let root = am.$section && am.$section.querySelector('.product-thumb-scroller__track');
      if (!root) return;
      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        children[i].classList.toggle('slick-current', i === index);
      }
    },

    ScrollThumbIntoView(index) {
      let am = this;
      let root = am.$section && am.$section.querySelector('.product-thumb-scroller__track');
      if (!root || !root.children[index]) return;
      root.children[index].scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'auto'
      });
    }
  }))  


  // Photo swipe zoom
  window.pswp_gallery = null;
  $(document).off('click').on('click', '.product__photo-zoom', (e) => {
    //console.log(e);
    if (window.pswp_gallery) {
      //window.pswp_gallery.destroy();
      window.pswp_gallery = null;
    }
    let $mainSection = $('.product-section:not(.hide-product)');
    let $images = $($mainSection).find('.photoswipe__image');
    let items = GetImageData($images);
    let index = e.target.dataset.index;

    var pswpElement = document.querySelectorAll('.pswp')[0];

    var options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: index - 1,
      pinchToClose: false,
      preloaderEl: false,
      scaleMode: 'zoom',
      shareEl: false,
      tapToToggleControls: false,
      getThumbBoundsFn: function(index) {
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var thumbnail = items[index].el;
        var rect = thumbnail.getBoundingClientRect();
        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
      }
    }

    let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    window.pswp_gallery = gallery;
    gallery.init();
  });
});
